import style from "./Navigation.module.css";

import { NavLink, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Icon from "@/ui/icon/Icon";

import { useUser } from "@/features/auth/hooks/useUser";

function Navigation() {
	const { t } = useTranslation();
	const { user } = useUser();

	return (
		<nav className={style.nav}>
			<ul className={style.navList}>
				{user?.role === "admin" && (
					<li className={style.navItem}>
						<Link to="admin" className={style.navLink}>
							<Icon icon="fa-crown" />
							<span>{t("common:nav.admin")}</span>
						</Link>
					</li>
				)}
				<li className={style.navItem}>
					<NavLink to="/" className={style.navLink}>
						<Icon icon="fa-house" />
						<span>{t("common:nav.home")}</span>
					</NavLink>
				</li>
				<li className={style.navItem}>
					<NavLink to="courses" className={style.navLink}>
						<Icon icon="fa-album-collection" />
						<span>{t("common:nav.courses")}</span>
					</NavLink>
				</li>
				<li className={style.navItem}>
					<NavLink to="paths" className={style.navLink}>
						<Icon icon="fa-scribble" />
						<span>{t("common:nav.pathsShort")}</span>
					</NavLink>
				</li>
				{!user?.is_subscribed && (
					<li className={style.navItem}>
						<NavLink to="plans" className={style.navLink}>
							<Icon icon="fa-tags" />
							<span>{t("common:nav.plans")}</span>
						</NavLink>
					</li>
				)}
			</ul>
		</nav>
	);
}

export default Navigation;
